module.exports = __webpack_public_path__ + "img/组 1138.d0743afe.png";